import { useContext } from "react";
import { useArchiveOrderMutation } from "@/features/organizations/api/ordersApi";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";
import { useOrder } from "@/hooks";
import useRoutes from "@/hooks/useRoutes";
import { getOrderDetails } from "@/utils/order";
import { Order } from "@/types";

const useSendThroughWhatsapp = () => {
  const [navigate] = useRoutes();
  const [archiveOrder] = useArchiveOrderMutation();
  const { deleteLSOrganizationOrder } = useOrder();
  const { organization } = useContext(WebsiteContext);

  const sendOrder = async (order: Order) => {
    if (!organization?.whatsapp || !order?.items?.length) return;

    const items = order.items
      .map((item: any) => {
        let dish = item.quantity + ". " + item.title;

        const settings = getOrderDetails(item);

        if (settings !== "") {
          dish = dish + "%0A" + settings;
        }

        if (item?.comments) {
          dish = dish + "%0A" + "Comentarios:" + "%0A" + item?.comments;
        }

        return dish;
      })
      .join("%0A");

    const email = order.client?.email ? `%2A Correo:${order.client?.email}` : "";
    const drivingInstructions = `https://www.google.com/maps/dir/?api=1%26origin%3D${organization.latitude}%2C${organization.longitude}%26destination%3D${order.deliveryLocation?.latitude}%2C${order.deliveryLocation?.longitude}%26travelmode%3Ddriving`;

    const isMapAvailable = order.deliveryLocation?.latitude && order.deliveryLocation?.longitude;

    const contactInfo = `%2A Nombre: ${order.client?.name}%0A %2A Telf: ${order.client?.phone}%0A  ${email}`;
    const location = `%2A Barrio: ${order.deliveryLocation?.neighborhood} %0A %2A No. Casa: ${order.deliveryLocation?.house} %0A %2A Instrucciones de Llegada: ${order.deliveryLocation?.address}`;
    const urlencodedtext = `%0A PEDIDO: %0A${items} %0A%0A CONTACTO: %0A${contactInfo} %0A%0A DIRECCIÓN: %0A${location} ${isMapAvailable ? drivingInstructions : ""} `;

    window.open(`https://wa.me/505${organization.whatsapp}?text=${urlencodedtext}`);

    // move order to archive collection
    await archiveOrder({
      orderId: order?.id, 
      organizationId: organization?.id
     });

    //remove order from local storage
    if (organization?.id) deleteLSOrganizationOrder();

    navigate("organizations.order.status", { orderId: order.id });
  };

  return sendOrder;
};

export default useSendThroughWhatsapp;
